var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.5857L10.2929 0.292887C10.6834 -0.0976337 11.3166 -0.0976265 11.7071 0.292902C12.0976 0.68343 12.0976 1.31659 11.7071 1.70712L6.7071 6.70701C6.31658 7.09753 5.68342 7.09753 5.2929 6.70701L0.2929 1.70711C-0.0976278 1.31659 -0.0976345 0.683429 0.292886 0.292901C0.683406 -0.0976274 1.31657 -0.0976345 1.7071 0.292886L6 4.5857Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.1e12016405ebd37971534be764a2c554.svg";
export { ForwardRef as ReactComponent };